const PATH = 'fe.components.calibrations.calibration_result_section';

const messages = {
  videoCriteria: {
    key: `${PATH}.video_criteria`,
    defaultValue:
      'In your calibration, you need to correctly code at least 80% of the dimensions'
  },
  scoreAbove: {
    key: `${PATH}.score_above`,
    defaultValue: 'You scored above'
  },
  scoreBelow: {
    key: `${PATH}.score_below`,
    defaultValue: 'You scored less than'
  },
  ExpertCodes: {
    key: `${PATH}.expert_codes`,
    defaultValue:
      'Review the scoring summary for this video to understand the rationale for the expert codes.'
  },
  button: {
    key: `${PATH}.button`,
    defaultValue: 'Expert Code Rationale'
  },
  pdf: {
    key: `${PATH}.pdf`,
    defaultValue: 'PDF icon'
  },
  score: {
    key: `${PATH}.score`,
    defaultValue: 'Test Score'
  }
};

export default messages;
